import UpdateMasterDataModal from "./UpdateMasterDataModal";

export default UpdateMasterDataModal;
